import SidebarNavigation from 'components/organisms/SidebarNavigation/SidebarNavigation';
import { FC } from 'react';
import { reportsSidebarConfig } from './ReportNavigation.constants';

const ReportNavigation: FC = () => {
  return <SidebarNavigation routes={reportsSidebarConfig} />;
};

export default ReportNavigation;
